export let INFO_POSITION_VALUES = /*#__PURE__*/function (INFO_POSITION_VALUES) {
  INFO_POSITION_VALUES[INFO_POSITION_VALUES["ON_VIDEOS"] = 1] = "ON_VIDEOS";
  INFO_POSITION_VALUES[INFO_POSITION_VALUES["BELOW_VIDEOS"] = 2] = "BELOW_VIDEOS";
  return INFO_POSITION_VALUES;
}({});
//# sourceMappingURL=info-position-values.js.map